module.exports = __webpack_public_path__ + "static/media/ki.d35b56d4.svg";